import { Legend } from 'chart.js';

let guardApplied = false;

export const applyChartLegendEventGuard = (): void => {
  if (guardApplied) return;
  guardApplied = true;

  const originalAfterEvent = Legend.afterEvent;
  if (!originalAfterEvent) return;

  Legend.afterEvent = (chart, args, options) => {
    if (!chart.legend) return;
    originalAfterEvent(chart, args, options);
  };
};
